/*eslint-disable*/
import { CloseIcon } from 'assets/icons/CloseIcon'
import { CheckBox } from 'components/CheckBox/CheckBox'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { Modal } from 'components/Modal/Modal'
import { ISelectValue } from 'constants/globalTypes'
import { useState } from 'react'
import { Button, CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import { dietaryPreferences } from './foodData'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'store'
import { createMealSupplier, editMealSupplier } from 'features/food/foodSlice'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import useModalClose from 'hooks/useModalClose'

export const MealSuppliersModal = ({ closeModal, value }: { closeModal: any, value?: IMealSupplierModalState }) => {
    const [state, setState] = useState<IMealSupplierModalState>(value || {
        name: '',
        dietaryPreferenceTypes: [],
        isConnectedWithFoodInventory: false,
    })
    const dispatch = useDispatch<AppDispatch>()

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setState(prev => ({ ...prev, name: e.target.value }))
    }
    const handleSelect = (v: ISelectValue[]) => {
        setState(prev => ({ ...prev, dietaryPreferenceTypes: v }))
    }

    const handleCheckBox = () => {
        setState(prev => ({ ...prev, isConnectedWithFoodInventory: !prev.isConnectedWithFoodInventory }))
    }

    const handleSave = async () => {
        const resp = await dispatch(value?.id ? editMealSupplier(state) : createMealSupplier(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            closeModal()
        }
    }


    useFocusFirstInput()
    useModalClose(closeModal)

    return <Modal black>
        <Flex column between center >
            <Flex column gap='1rem' width='100%' >
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold' >{value?.id ? 'Edit' : 'Add'} Meal Supplier</TitleText>
                    <CursorPointer onClick={closeModal} >
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input placeholder='Food Company Ltd...' labelText='Supplier name' value={state.name} onChange={handleChange} nomarg invalid={!state.name} />
                <HonestSelectInput options={dietaryPreferences} defaultValue={state.dietaryPreferenceTypes} labelText='Dietary preference' onChange={handleSelect} multi invalid={!state.dietaryPreferenceTypes} />
                <CheckBox square state={state.isConnectedWithFoodInventory} onClick={handleCheckBox} title='Connect supplier with food inventory' />
            </Flex>
            <Button mt='40' orange disabled={!state.name || !state.dietaryPreferenceTypes.length} onClick={handleSave} >Save</Button>
        </Flex>
    </Modal>
}

export interface IMealSupplierModalState {
    id?: number
    name: string
    dietaryPreferenceTypes: ISelectValue[]
    isConnectedWithFoodInventory: boolean
}